const assetLoaders: Promise<void>[] = [];

function loadImage(url: string): HTMLImageElement {
  const img = new Image();
  assetLoaders.push(
    new Promise((resolve) => {
      img.onload = () => {
        resolve();
      };
      img.onerror = () => resolve();
    })
  );
  img.src = url;

  return img;
}

function loadAudio(url: string, volume?: number): HTMLAudioElement {
  const audio = new Audio(url);
  assetLoaders.push(
    new Promise((resolve) => {
      audio.onloadeddata = () => {
        resolve();
      };

      if (volume) {
        audio.volume = volume;
      }

      audio.onerror = () => resolve();
    })
  );
  audio.src = url;
  return audio;
}

export const assets = {
  images: {
    defensive: loadImage('/images/run.png'),
    offensive: loadImage('/images/aim.png'),
    guarding: loadImage('/images/guarding.png'),
    dead: loadImage(
      'https://em-content.zobj.net/thumbs/120/openmoji/338/headstone_1faa6.png'
    ),
    flag: loadImage('/images/flag.png'),
    brush: [
      // load('/images/brush-3.png'),
      // load('/images/brush-3.png'),
      loadImage('/images/brush-4.png'),
      loadImage('/images/brush-5.png'),
      loadImage('/images/brush-5.png'),
      loadImage('/images/brush-5.png'),
      loadImage('/images/brush-5.png'),
    ],
    rock: [
      loadImage('/images/rock-4.png'),
      loadImage('/images/rock-4.png'),
      loadImage('/images/rock-4.png'),
      loadImage('/images/rock-5.png'),
      loadImage('/images/rock-5.png'),
      loadImage('/images/rock-6.png'),
    ],
    grass: [
      loadImage('/images/dirt-1.png'),
      loadImage('/images/dirt-2.png'),
      loadImage('/images/dirt-3.png'),
      // load('/images/grass-2.png'),
      // load('/images/grass-3.png'),
    ],

    items: {
      medkit: loadImage('/images/medkit.png'),
      medkit2: loadImage('/images/medkit-2.png'),
      grenade: loadImage('/images/grenade.png'),
      boots: loadImage('/images/boots.png'),
      pistol: loadImage('/images/pistol.png'),
      knife: loadImage('/images/knife.png'),
      armor: loadImage('/images/armor.png'),
      energydrink: loadImage('/images/energydrink.png'),
    },
  },

  sounds: {
    pistol: loadAudio('/sounds/gunshot.mp3'),
    slash: loadAudio('/sounds/slash.mp3'),
    death: loadAudio('/sounds/death.mp3'),
    grenade: loadAudio('/sounds/grenade.mp3', 0.2),
    itemImproved: loadAudio('/sounds/item-improved.mp3'),
    reload: loadAudio('/sounds/pistol-reload.mp3'),
    horn: loadAudio('/sounds/horn.mp3'),
    click: loadAudio('/sounds/click.mp3'),
  },
};

export function playSound(sound: HTMLAudioElement) {
  console.log('Playing sound', sound.src);

  sound.currentTime = 0;
  sound.play();
}

export function waitForAssets() {
  return Promise.all(assetLoaders);
}
